var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup183(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.161,
    cy: 53.16,
    r: 51.831,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 2.658
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3786 28.9634V31.1775H21.4133V28.9634H86.3786ZM87.7909 27.8564H20.001V32.2845H87.7909V27.8564Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7911 58.0232H64.4883",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3171 37.8198C81.9474 37.8198 84.1541 39.2313 84.7897 41.1409H68.1953C68.8308 39.2313 71.0375 37.8198 73.6679 37.8198H79.3171ZM79.3171 36.7128H73.6679C69.7664 36.7128 66.6064 39.1898 66.6064 42.248H86.3785C86.3785 39.1898 83.2185 36.7128 79.3171 36.7128Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6993 32.2154V36.5051H74.2859V32.2154H78.6993ZM80.0233 31.1775H72.9618V37.543H80.0233V31.1775ZM63.0758 32.2846V41.1409H21.4133V32.2846H63.0758ZM64.4881 31.1775H20.001V42.2479H64.4881V31.1775Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8915 32.2846V41.1409H21.4133V32.2846H41.8915ZM43.3038 31.1775H20.001V42.2479H43.3038V31.1775ZM86.3786 61.0676V76.5661H21.4133V61.0676H86.3786ZM87.7909 59.9605H20.001V77.6732H87.7909V59.9605Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9507 61.0676V76.5662H21.4133V61.0676H42.9507ZM44.363 59.9606H20.001V77.6732H44.363V59.9606ZM86.3786 61.0676V76.5662H65.9004V61.0676H86.3786ZM87.7909 59.9606H64.4881V77.6732H87.7909V59.9606Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7887 65.4957V74.3521H70.4903V65.4957H81.7887ZM83.2009 64.3887H69.078V75.4591H83.2009V64.3887ZM86.3786 77.6732V79.8873H21.4133V77.6732H86.3786ZM87.7909 76.5661H20.001V80.9943H87.7909V76.5661Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4178 56.3626C33.4178 54.9927 31.9879 53.8718 30.2402 53.8718C28.4924 53.8718 27.0625 54.9927 27.0625 56.3626V59.9605",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.55 62.867C71.6477 62.867 71.7269 62.8049 71.7269 62.7284C71.7269 62.6518 71.6477 62.5898 71.55 62.5898C71.4523 62.5898 71.373 62.6518 71.373 62.7284C71.373 62.8049 71.4523 62.867 71.55 62.867Z",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7302 62.867C80.8279 62.867 80.9071 62.8049 80.9071 62.7284C80.9071 62.6518 80.8279 62.5898 80.7302 62.5898C80.6324 62.5898 80.5532 62.6518 80.5532 62.7284C80.5532 62.8049 80.6324 62.867 80.7302 62.867Z",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6042 62.867C74.7019 62.867 74.7811 62.8049 74.7811 62.7284C74.7811 62.6518 74.7019 62.5898 74.6042 62.5898C74.5065 62.5898 74.4272 62.6518 74.4272 62.7284C74.4272 62.8049 74.5065 62.867 74.6042 62.867Z",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7287 62.867C77.8264 62.867 77.9056 62.8049 77.9056 62.7284C77.9056 62.6518 77.8264 62.5898 77.7287 62.5898C77.631 62.5898 77.5518 62.6518 77.5518 62.7284C77.5518 62.8049 77.631 62.867 77.7287 62.867Z",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5342 39.6187H33.771M51.4247 39.6187H55.6615M47.0113 67.1563V70.4774M40.1264 67.1563V70.4774",
    stroke: "black",
    strokeWidth: 1.42129,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup183);
export default __webpack_public_path__ + "static/media/Group 18 (3).d2a440c92d8df14f56f60628f47e0ab7.svg";
export { ForwardRef as ReactComponent };